var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { utils as dataUtils } from '@easydata/core';
import { eqconsts, equtils } from '@easyquery/core';
import { createBrowserEvent, domel } from '@easydata/ui';
import { ConditionRenderer, SimpleConditionRenderer } from './condition_renderer';
import { browserUtils } from '../../../utils/browser_utils';
import { dropdown } from '../../../utils/dropdown';
var ConditionGroupRenderer = /** @class */ (function (_super) {
    __extends(ConditionGroupRenderer, _super);
    function ConditionGroupRenderer(panel, condition, slot) {
        var _this = _super.call(this, panel, condition, slot) || this;
        _this.isRoot = !condition.getParent();
        return _this;
    }
    ConditionGroupRenderer.prototype.getClassesToAdd = function () {
        var result = this.cssPrefix + "-group";
        if (this.isRoot) {
            result += " " + this.cssPrefix + "-group-root";
        }
        return result;
    };
    ConditionGroupRenderer.prototype.coreRender = function (autoAppear) {
        domel(this.element)
            .addClass(this.getClassesToAdd())
            .addClass(browserUtils.getMobileCssClass())
            .addChildElement(this.renderGroupRow())
            .addChildElement(this.renderConditions(autoAppear))
            .data('id', this.condition.id)
            .data('group', '');
    };
    ConditionGroupRenderer.prototype.renderGroupRow = function () {
        if (this.isRoot && !this.panel.options.showRootRow) {
            return null;
        }
        else {
            return new ConditionGroupRowRenderer(this.panel, this.condition).render();
        }
    };
    ConditionGroupRenderer.prototype.renderConditions = function (autoAppear) {
        var _this = this;
        var builder = domel('div');
        builder
            .addClass(this.cssPrefix + "-conditions")
            .addClass("" + browserUtils.getMobileCssClass())
            .data('conditions', '');
        if (this.isRoot) {
            builder.addClass(this.cssPrefix + "-conditions-root");
        }
        this.condition.getConditions().forEach(function (condition, index, array) {
            var renderer = _this.panel.getConditionRenderer(condition);
            if (renderer) {
                builder.addChildElement(renderer.render(autoAppear && index == array.length - 1));
            }
        });
        return builder.toDOM();
    };
    return ConditionGroupRenderer;
}(ConditionRenderer));
export { ConditionGroupRenderer };
var ConditionGroupRowRenderer = /** @class */ (function (_super) {
    __extends(ConditionGroupRowRenderer, _super);
    function ConditionGroupRowRenderer(panel, condition, slot) {
        var _this = _super.call(this, panel, condition, slot) || this;
        _this.isRoot = !_this.condition.getParent();
        return _this;
    }
    ConditionGroupRowRenderer.prototype.getButtonsToShow = function () {
        return this.panel.options.buttons && this.panel.options.buttons.group && Array.isArray(this.panel.options.buttons.group) ? this.panel.options.buttons.group : ["addCondition", "addGroup", "enable", "delete"];
    };
    ConditionGroupRowRenderer.prototype.getClassesToAdd = function () {
        var result;
        if (this.isRoot) {
            result = this.cssPrefix + "-row " + this.cssPrefix + "-row-group " + this.cssPrefix + "-row-group-root";
        }
        else {
            result = this.cssPrefix + "-row " + this.cssPrefix + "-row-group";
            var level = this.condition.getLevel();
            if (level > 0)
                result += " " + this.cssPrefix + "-level-" + level;
            result += this.condition.enabled ? '' : " " + this.cssPrefix + "-disabled";
            if (this.condition.enabled) {
                result += this.condition.isReadOnly() ? " " + this.cssPrefix + "-readonly" : '';
            }
        }
        return result;
    };
    ConditionGroupRowRenderer.prototype.coreRender = function (autoAppear) {
        var _this = this;
        var builder = domel(this.element)
            .addClass(this.getClassesToAdd())
            .addClass(browserUtils.getMobileCssClass())
            .data('group-row', '')
            .addChildElement(this.renderCheckbox())
            .addChildElement(this.renderConjunction());
        var level = this.condition.getLevel();
        if (level > 0)
            builder.addClass(this.cssPrefix + "-level-" + level);
        this.buildGroupElements(builder, this.getGroupTitle());
        if (this.panel.options.accentActiveCondition) {
            builder.on('click', function (ev) {
                _this.panel.toggleConditionPicked(_this.condition);
                _this.adjustButtonsVisibility();
                if (!browserUtils.isMobileMode()) {
                    builder.toDOM().dispatchEvent(createBrowserEvent("mouseenter"));
                }
            });
        }
        builder
            .addChildElement(this.renderButtonsBlock());
        if (!browserUtils.isMobileMode()) {
            builder
                .on('mouseenter', function (event) {
                _this.isMouseOverBlock = true;
                _this.enterButtonBlock();
                event.stopPropagation();
                return false;
            })
                .on('mouseleave', function (event) {
                _this.isMouseOverBlock = false;
                if (!_this.keepShowingButtons && domel(_this.buttonsBlock).isVisible()) {
                    _this.leaveButtonBlock();
                }
                event.stopPropagation();
                return false;
            });
        }
    };
    ConditionGroupRowRenderer.prototype.getGroupTitle = function () {
        var result;
        if (this.isRoot && !browserUtils.isMobileMode()) {
            result = i18n.getText('RootConditionGroupTitle');
            if (!result) {
                //to support old text key
                result = i18n.getText('RootPredicateTitle');
            }
        }
        else {
            result = i18n.getText('ConditionGroupTitle');
            if (!result) {
                //to support old text key
                result = i18n.getText('PredicateTitle');
            }
        }
        return result;
    };
    ConditionGroupRowRenderer.prototype.buildGroupElements = function (builder, groupTitle) {
        var _this = this;
        var pos = groupTitle.indexOf('{lt}');
        if (pos < 0) {
            //invalid format
            builder.addText(i18n.getText('ErrIncorrectGroupTitleFormat'));
            builder.addClass(this.cssPrefix + "-error");
        }
        else {
            if (pos > 0) {
                builder.addChild('span', function (b) {
                    b.addClass(_this.cssPrefix + "-grelement")
                        .addText(groupTitle.substring(0, pos));
                });
            }
            var linkTypeStr = equtils.linkTypeToStr(this.condition.linkType);
            var curType_1 = dataUtils.findItemById(eqconsts.predicateLinkTypeList, linkTypeStr);
            if (!curType_1) {
                curType_1 = eqconsts.predicateLinkTypeList[0];
            }
            if (this.isEditable()) {
                dropdown(builder.toDOM())
                    .onGetMenu(function () { return _this.getLinkTypeMenu(); })
                    .onItemSelected(function (id) {
                    _this.condition.linkType = equtils.strToLinkType(id);
                    _this.condition.fireChangedEvent();
                })
                    .addText(i18n.getText(curType_1.key))
                    .title(i18n.getText(curType_1.key))
                    .addClass(this.cssPrefix + "-grelement");
            }
            else {
                builder.addChild('span', function (b) {
                    b.text(i18n.getText(curType_1.key))
                        .title(i18n.getText(curType_1.key))
                        .addClass(_this.cssPrefix + "-grelement");
                });
            }
            builder.addChild('span', function (b) {
                b.addClass(_this.cssPrefix + "-grelement")
                    .addText(groupTitle.substring(pos + 4));
            });
        }
    };
    ConditionGroupRowRenderer.prototype.getConditionMenu = function () {
        return this.panel.getConditionGroupMenu(this.condition.getParent() == null);
    };
    ConditionGroupRowRenderer.prototype.getLinkTypeMenu = function () {
        return this.panel.getLinkTypeMenu();
    };
    ConditionGroupRowRenderer.prototype.renderConjunction = function () {
        return this.isRoot ? null : _super.prototype.renderConjunction.call(this);
    };
    ConditionGroupRowRenderer.prototype.renderCheckbox = function () {
        return this.isRoot ? null : _super.prototype.renderCheckbox.call(this);
    };
    ConditionGroupRowRenderer.prototype.leaveButtonBlock = function () {
        if (!this.panel.options.alwaysShowButtonsInGroups
            && (!this.isConditionActive() || !this.panel.options.accentActiveCondition)) {
            this.hideButtons();
        }
    };
    ConditionGroupRowRenderer.prototype.adjustButtonsVisibility = function () {
        if (this.panel.options.alwaysShowButtonsInGroups
            || (this.panel.options.accentActiveCondition && this.isConditionActive())) {
            this.showButtons();
        }
    };
    return ConditionGroupRowRenderer;
}(SimpleConditionRenderer));
export { ConditionGroupRowRenderer };
//# sourceMappingURL=condition_group_renderer.js.map